import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { DbVersionGetterState, DbVersionsGetterState } from "../ngxs/dbVersion/dbVersion-getter.state";
import { Observable } from "rxjs";
import { DbVersionsStateModel, LatestDbVersionStateModel, GetLatestDbVersionRequestState } from "../ngxs/dbVersion/dbVersion.state";
import { IRequest } from "ngxs-requests-plugin";
import { GetLatestDbVersion, GetDbVersions } from "../ngxs/dbVersion/dbVersion.actions";

@Injectable({
  providedIn: 'root',
})
export class DbVersionService {
  @Select(DbVersionGetterState.GetLatestDbVersion)
  dbVersion$: Observable<LatestDbVersionStateModel>;

  @Select(DbVersionsGetterState.GetDbVersions)
  dbVersions$: Observable<String[]>;

  @Select(GetLatestDbVersionRequestState)
  GetLatestDbVersionRequestState$: Observable<IRequest>;

  constructor(
    private store: Store
  ) {}

  GetLatestDbVersion() {
    this.store.dispatch(new GetLatestDbVersion());
  }

  GetLatestDbVersionSnapshot() {
    return this.store.selectSnapshot(DbVersionGetterState.GetLatestDbVersion);
  }

  GetDbVersions() {
    this.store.dispatch(new GetDbVersions());
  }
}